export default "__VITE_ASSET__BlY3YfkH__"